module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-row', {
    attrs: {
      "title": "Variant",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(0)
      }
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(1)
      }
    }
  }, [_vm._v("Long content")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(2)
      }
    }
  }, [_vm._v("Scroll")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(3)
      }
    }
  }, [_vm._v("Fullscreen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(20)
      }
    }
  }, [_vm._v("Scroll & Fullscreen")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "margin": 2,
      "title": "Position"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(7)
      }
    }
  }, [_vm._v("top left")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(8)
      }
    }
  }, [_vm._v("top")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(9)
      }
    }
  }, [_vm._v("top right")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(4)
      }
    }
  }, [_vm._v("left center")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(5)
      }
    }
  }, [_vm._v("center")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(6)
      }
    }
  }, [_vm._v("right center")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(10)
      }
    }
  }, [_vm._v("bottom left")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(11)
      }
    }
  }, [_vm._v("bottom")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(12)
      }
    }
  }, [_vm._v("bottom right")])])])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Scroll with left/right position",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(13)
      }
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(14)
      }
    }
  }, [_vm._v("Right")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Header and footer slots",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(15)
      }
    }
  }, [_vm._v("Header")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(16)
      }
    }
  }, [_vm._v("Footer")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-small uk-button-primary",
    on: {
      "click": function($event) {
        _vm.openModal(17)
      }
    }
  }, [_vm._v("Header & Footer")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Callback",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(18)
      }
    }
  }, [_vm._v("onDismiss")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(19)
      }
    }
  }, [_vm._v("onClose")])])]), _vm._v(" "), _c('page-row', {
    attrs: {
      "title": "Other",
      "margin": 2
    }
  }, [_c('div', {
    staticClass: "uk-button-group"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(21)
      }
    }
  }, [_vm._v("Multi modals")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(22)
      }
    }
  }, [_vm._v("Escapable")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-button-small",
    on: {
      "click": function($event) {
        _vm.openModal(23)
      }
    }
  }, [_vm._v("Without dismiss by pressing the mask")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30057a17","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/examples.vue
// module id = 220
// module chunks = 1